// 选择取件人
<template>
  <div class="mailSelectConsignee">

    <!-- 流程 -->
    <userSaveFlow></userSaveFlow>

    <!-- 正文内容 [员工]类型:显示选择取件人界面,[快递员]类型:显示查询取件人界面-->
    <div class="search-wrapper">
      <!-- 选择取件人[员工] -->
      <div class="search-box" v-if="userAuthType=='staff'">
        <div class="top">
          <p class="title">选择取件人</p>
        </div>
        <div class="input-box">
          <el-input placeholder="请输入手机号或姓名首字母搜索" v-model="keyWord"></el-input>
          <img class="clearkeyWord" v-if="keyWord!=''" src="../../../../static/mailBox/images/icon/delete.png" @click="clearkeyWord()"/>
          <el-button class="btn-search" type="primary" @click="getUserListByBox()" round>搜索</el-button>
        </div>

        <div class="user-box" v-if="departmentList.length !== 0">
          <div class="scroll-left">
            <!-- 一级部门 -->
            <div 
              class="group"
              :class="[active === departmentList[0].id ? 'active' : '']"
              @click="getGroupUserList(departmentList[0].id)">{{departmentList[0].name}}</div>
              
            <!-- 二级部门 -->
            <div
              class="group second one-line-overhidden"
              :class="[active === item.id ? 'active' : '']"
              v-for="item in departmentList[0].children"
              :key="item.id" @click="getGroupUserList(item.id)">{{item.name}}</div>

            <keep-alive>
              <multiSelector
                class="group department-list"
                :value.sync="selectedDepartmentId"
                :data="departmentList"
                :props="props"
                placeholder="请选择下级部门"
                @confirm="handleConfirm"
                v-if="!isSearch"></multiSelector>
            </keep-alive>

          </div>
            
          
          <!-- 联系人列表 -->
          <!-- <div class="member-scroll"> -->
            <div
              class="member-list"
              :class="{'search-list': isSearch}"
               v-if="userData.list.length !== 0"
              v-loading="userData.loading">
              <div
                class="member"
                v-for="(item, index) in userData.list"
                :class="{'myself': item.user_id === $store.state.mail_senderId}"
                :key="index"
                @click="selectStaff(item, index)">
                  <div>
                    <span class="name" v-text="item.user_name"></span>
                    <span class="phoneNo" v-text="item.phone_no"></span>
                  </div>
                  <span class="selectSpan" :class="{selected: item.selected}"></span>
                </div>
              </div>
            <!-- </div> -->
            <!-- </keep-alive> -->
          <!-- 联系人不存在 -->
          <div  class="content-null" v-else>
            <img src="../../../../static/turnoverCabinet/images/icon/search_list.png" alt="">
            <p class="text">{{isSearch ? '联系人不存在' : '当前部门没有联系人'}}</p>
          </div>
        </div>

        <!-- 确定联系人按钮 -->
        <div class="btn-area">
            <span
            class="btn-confirm"
              @click="CheckedByStaff()">确定</span>
          </div>
      </div>

      <!-- 查询取件人[快递员] -->
      <div class="express-search-box" v-else>
        <div class="input-box">
          <el-input 
            maxlength="11"
            v-model="expresskeyWord" 
            placeholder="请输入手机号码" >
          </el-input>
          <img class="clearkeyWord" v-if="expresskeyWord!=''" src="../../../../static/mailBox/images/icon/delete.png" @click="clearkeyWord()"/>
          <span class="exactName" v-if="expresskeyWord.length==11 && matchSearch.length!=0">{{matchSearch[0].user_name}}</span>
        </div>

        <p class="prompt" v-if="matchSearch.length>0 && matchSearch.length<=2 && expresskeyWord.length!=11">您可能想投递至</p>
        
        <div class="consignee-box" v-if="matchSearch.length>0 && matchSearch.length<=2 && expresskeyWord.length!=11">
          <span v-for="(item) in matchSearch" :key="item.phone" @click="checkName(item.phone_no)">{{item.user_name}}</span>
        </div>

        <div class="btn" @click="CheckedByExpress">确定</div>
      </div>

    </div>

    <!-- 底部按钮 -->
    <!-- <btnCancel @click.native="cancelBack"></btnCancel> -->
    <btnCancel></btnCancel>

  </div>
</template>

<script>
// 组件
import btnCancel from '../common/btnCancel.vue'
import userSaveFlow from '../userSave/userSaveFlow'
import multiSelector from '../module/multi-selector.vue'

// js
import {
  showToast,
  getUserListByBox,
  getDepartmentList,
  checkUserPhone,
} from '../../../../static/mailBox/js/request.js'
import { storage } from '../../../../static/js/utils/utility'

export default {
  name: 'mailBoxSelectConsignee',

  components: {
    btnCancel,
    userSaveFlow,
    multiSelector,
  },

  data () {
    return {
      // 侧边栏选中
      active: '0',
      isSearch: false,
      selecteWapperStatus: false,
      // 部门数据
      departmentList: [],
      selectedDepartmentId: '',
      props: {
        value: 'id',
        parent_value: 'parent_id',
        lable: 'name',
        children: 'children'
      },
      // 全部的用户数据
      userData: {
        list: [],
        loading: false,
        selected: {}
      },
      keyWord: '',
      memberHeight: '',
      expresskeyWord: '',
    }
  },
  
  created () {
    console.log('用户选择的业务类型：', this.$store.state.mail_oType)
    console.log('用户的身份：', this.$store.state.mail_type)
    // this.$store.state.mail_index = 2
    this.$store.commit('mail_index', 2)
    this.userAuthType = this.$store.state.mail_type
    // 获取授权的员工部门列表
    if (this.$store.state.mail_type === 'staff') {
      this.getDepartmentList(storage.localGetItem('device_no_id'))
    }
    // 获取全部员工列表(department_id: "0")
    this.getGroupUserList('0')
  },

  mounted () {

  },

  computed: { // matchSearch可以定义为methods，但计算属性会产生缓存，不必每次都重新执行
    matchSearch () {
      let result = []
      let keyWord = this.expresskeyWord // matchSearch的改变取决于expresskeyWord
      console.log('输入值：', keyWord) // 1|17|173|1732854 
      this.userData.list.map(item => {
        if(String(item.phone_no).search(keyWord) != -1) {
          result.push(item)
        }
      })
      console.log('匹配的值：', result)
      return result
    },
  },

  methods: {
    // 获取授权的员工部门列表
    getDepartmentList: async function (device_no_id) {
      let vm = this
      // vm.userData.loading = true
      let data = {'device_no_id': device_no_id}
      let res = await getDepartmentList(data)
      if (res.meta.code === 200) {
      // console.info('获取授权的员工部门列表:', res.data[0].children[0])
        vm.departmentList = res.data
      } else {
        showToast(res.meta.message)
      }
      // vm.userData.loading = false
    },

    // 一级、二级部门获取部门用户列表
    getGroupUserList(id) {
      console.log('默认选中的部门id：', id)
      let vm = this
      vm.active = id
      vm.getUserListByBox(id)
    },

    // 获取员工列表
    getUserListByBox: async function (id = '') {
      let vm = this
      vm.userData.loading = true
      // 清空上次选择用户信息
      vm.userData.selected = {}
      let data = {
        department_id: id,
        device_no_id: storage.localGetItem('device_no_id'),
      }
      if (vm.keyWord !== '') {
        if (String(Number(vm.keyWord)) == 'NaN') { // 姓名
          data = {...data, user_name: vm.keyWord}
        } else {
          data = {...data, phone_no: vm.keyWord}
        }
      }
      let res = await getUserListByBox(data)
      console.info('获取员工列表：', res)
      if (res.meta.code === 200) {
        let list = res.data.list
        for (let i in list) {
          list[i].selected = false
        }
        vm.userData.list = [...list]

        vm.isSearch = vm.keyWord === '' ? false : true
        // console.log('userData：', vm.userData.list)
      } else {
        showToast(res.meta.message)
      }
      vm.userData.loading = false
    }, 

    // 搜索取件人
    searchUser: async function () {

    },

    // 确认部门
    handleConfirm (e) {
      console.log('选择下级部门：', e)
      if (e.detail.length === 0) {
        showToast('请选择部门')
        return
      } else {
        this.active = 'select'
        this.selectedDepartmentId = e.value
        this.getUserListByBox(e.value)
      }
    },

    // 选中取件人
    selectStaff: function (staffItem, staffIndex) {
      console.log('选中取件人：', staffItem)
      // 当为投递者，不能选择
      if (staffItem.user_id === this.$store.state.mail_senderId) {
        showToast('不能投给自己')
        return
      }
      for (let i in this.userData.list) { 
        // $set可以新增属性，并触发视图更新
        this.$set(this.userData.list[i], 'selected', false)
      }
      this.$set(this.userData.list[staffIndex], 'selected', true)
      this.userData.selected = staffItem
    },

    // [staff类型] 点击确认
    CheckedByStaff: function () {
      let vm = this
      console.log('vm.userData：', vm.userData.selected)
      // 未选择取件人
      if (!vm.userData.selected.user_id) {
        showToast('请选择取件人')
        return
      }
      // let device_no_id = storage.localGetItem('device_no_id')
      let {user_id, phone_no, box_number} = vm.userData.selected
      // vm.$store.state.mail_deliver = {...vm.$store.state.mail_deliver, user_id, phone_no}
      let mail_deliver = {user_id, phone_no, box_number}
      console.warn('mail_deliver:::', mail_deliver)
      vm.$store.commit('mail_deliver', mail_deliver)
      vm.goScanExpressCode()
    },
    
    // [express类型] 选中匹配到的名字
    checkName: function (phone) {
      console.log('选中名字的号码：', phone)
      this.expresskeyWord = phone
    },

    // [express类型] 点击确认
    CheckedByExpress: async function () {
      let vm = this
      console.info('输入值：', vm.expresskeyWord, vm.expresskeyWord.length)
      if(vm.expresskeyWord === '') {
        showToast('请输入取件人手机号码')
        return
      } else if (vm.expresskeyWord.length != 11) {
        showToast('请输入正确的手机号码')
        return
      }
      let data = {
        'phone_no': vm.expresskeyWord,
        'device_no_id': storage.localGetItem('device_no_id'), 
      }
      console.warn('检测授权的数据：', data)
      let res = await checkUserPhone(data)
      if (res.meta.code === 200) {
        let user_id = res.data.user_id
        let {phone_no,} = data
        // let user_name = matchSearch[0].user_name
        // vm.$store.state.mail_deliver = {...vm.$store.state.mail_deliver, user_id, phone_no}
        let mail_deliver = {user_id, phone_no}
        vm.$store.commit('mail_deliver', mail_deliver)
        vm.goScanExpressCode()
      } else {
        showToast(res.meta.message)
      }
    },

    // 已确认取件人，进入扫码投递页面
    goScanExpressCode: function () {
      let vm = this
      vm.$router.push({
        path: '/mailBox/userSave/scanExpressCode',
      })
    },

    // 清空搜索框
    clearkeyWord() {
      let vm = this
      vm.expresskeyWord = ''
      vm.keyWord = ''
    },
  },

  // 监听关键字变化
  watch: {
    keyWord (newVal) {
      // console.warn('搜索取件人信息：', newVal)
      if (newVal === '') {
        this.getUserListByBox(this.selectedDepartmentId)
        this.isSearch = false
      }
    }
  },
}
</script>

<style lang='less'>
.mailSelectConsignee {
  width: 100%;
  .search-wrapper {
    position: static;
    // margin: 0.8rem auto 0;
    background-color: transparent;
    .search-box {
      .input-box {
        position: relative;
        .el-input__clear {
          font-size: 0.4rem;
        }
      }
    }
    
    .express-search-box {
      .input-box {
        .el-input {
          height: 1rem;
          line-height: 1rem;
          background-color: #FFF;
          border-radius: 4px;
          border: 1px solid #DCDFE6;
          // -webkit-box-sizing: border-box;
          box-sizing: border-box;
          .el-input__suffix {
            display: none;
          }
          .el-input__inner {
            border: none;
            font-size: 0.36rem;
          }
        }
      }
      
    }
  }
  // height: 100%;
  .clearkeyWord {
    display: block;
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    right: 0.2rem;
    top: 0;
    bottom: 0;
    margin: auto 0;
  }
  .search-box {
    .clearkeyWord {
      right: 1.9rem;
    }
  }
  .one-line-overhidden {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }

  .department-list .end-selected-view {
    font-size: 0.26rem;
  }

  .department-list .yt-selected-view {
    width: 50%;
    height: 50%;
    top: 0;
    margin: auto;
  }

  .search-wrapper .search-box,
  .search-wrapper .express-search-box {
    width: 7.6rem;
    // height: 8.8rem;
    height: 7.8rem;
    margin: 0.6rem auto 0;
    // margin: 0 auto;
    text-align: center;
    border-radius: 0.1rem;
    box-sizing: border-box;
    /* background-color: #ffffff; */
  }

  .search-wrapper 
  {
    .close {
      display: block;
      width: 50px;
      height: 50px;
      background-size: 50px;
      background: url(../../../../static/mailBox/images/icon/close.png) center no-repeat;
      position: absolute;
      top: 10px;
      right: 10px;
    }

    .search-box {
      background-color: #ffffff;
      .top {
        position: relative;
        .title {
          font-size: 0.34rem;
          line-height: 0.88rem;
          font-weight: bold;
          color: #ffffff;
          background-color: #0d508f;
        }
      }
      .input-box {
        padding: 0.2rem;
        background-color: #f1f1f1;
        /* border-bottom: 1px solid #cccccc; */
        display: flex;
        align-items: center;
        justify-content:space-between;
        .el-input {
          width: 5.6rem;
          height: 0.58rem;
          float: left;
        }
        .btn-search {
          width: 1.43rem;
          border-radius: 3px;
          float: right;
          padding: 0;
        }
      }
      .user-box {
        display: flex;
        // height: 6.05rem;
        // height: 5.05rem;
        .scroll-left {
          background-color: #f6f6f8;
          // height: 6.05rem;
          width: 2.9rem;
          height: 5.05rem;
          text-align: left;
          // overflow-x: hidden;
          overflow-y: auto;
          flex-shrink: 0;
        }
        .group {
          // width: 2.9rem;
          color: #333333;
          font-size: 0.26rem;
          line-height: 0.9rem;
          text-indent: 0em;
          position: relative;
          padding-left: 0.4rem;
        }
        .group::after {
          display: block;
          content: '';
          width: auto;
          height: 0.02rem;
          background-color: #ececee;
          position: absolute;
          bottom: 0;
          left: 1em;
          right: 1em;
        }
        .group.second {
          // padding-left: 0.08rem;
        }
        .group.active {
          color: #2d83f3;
          background-color: #fff;
          border-left: 0.08rem solid #2d83f3;
          padding-left: 0.32rem;
        }
        .department-list,
        .content-null{
          // width: 2.9rem;
          // height: 6.05rem;
          position: relative;
        }
        .department-list {
          background-color: #f1f1f1;
          overflow: visible;
        }
        // .member-scroll {
        //   flex-grow: 1;
        //   padding: 0 0.6rem 0 0.4rem;
        // }
        .member-list {
          overflow-y: auto;
          overflow-x: hidden;
          // padding-right: 0.5rem;
          flex-grow: 1;
          padding: 0 0.6rem 0 0.4rem;
          height: 5.05rem;
          position: relative;
          box-sizing: border-box;
        
        // .member-list::after {
        //   content: '';
        //   width: 20px;
        //   height: 100%;
        //   background-color: #ffffff;
        //   position: absolute;
        //   right: -20px;
        //   top: 0;
        //   z-index: 9999;
        // }
          &.search-list {
            width: 100%;
            // height: 6.05rem;
            height: 5.05rem;
          }
          .member {
            display: flex;
            justify-content:space-between;
            align-items: center;
            // width: 100%;
            height: 0.88rem;
            font-size: 0.24rem;
            color: #0d508f;

          }
          .member.myself {
            color: #cccccc;
          }
          .el-scrollbar__wrap {
            width: 100%;
            overflow: hidden;
          }
          .member {
            padding: 0.12rem 0 0.02rem;
            border-bottom: 1px solid #f9f9f9;
            position: relative;
          }
          .member span{
            display: block;
            text-align: left;
            line-height: 0.35rem;
          }
          .member span.phoneNo{
            font-size: 0.20rem;
          }
          .member span.selectSpan {
            width: 0.34rem;
            height: 0.34rem;
            border-radius: 50%;
            padding: 0.01rem;
            border: 1px solid #cccccc;
            // position: absolute;
            // // bottom: 0;
            // top: 50%;
            // right: 0;
            // margin-top: -0.17rem;

            // margin: auto 0;
          }
          .member span.selectSpan.selected {
            border:none;
            padding: 0;
            background: url(../../../../static/mailBox/images/selected.png) center no-repeat;
            background-size: 0.34rem 0.34rem;
          }
        }
      }
    }

    .btn-confirm {
      display: block;
      width: 1.45rem;
      margin: 0.15rem auto 0;
      height: 0.58rem;
      font-size: 0.22rem;
      line-height: 0.58rem;
      color: #ffffff;
      border-radius: 5px;
      background-color: #49aafe;
    }

    .content-null {
      width: 100%;
      margin:  0 auto;
      padding-top: 1rem;
    }

    .content-null img {
      width: 1rem;
      height: 1rem;
      margin: 0.4rem;
    }

    .content-null .text {
      font-size: 0.3rem;
      color: #bfbfbf;
    }

    .btn-area {
      width: 100%;
      height: 0.88rem;
      border-top: 1px solid #f0f0f0;
    }
  }

  .search-wrapper .express-search-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: none;
    .input-box {
      width: 100%;
      position: relative;
      .exactName {
        color: #C0C4CC;
        font-size: 0.36rem;
        position: absolute;
        top: 50%;
        right: 0.72rem;
        transform: translateY(-50%);
      }
    }
    .prompt {
      font-size: 0.35rem;
      margin: 0.4rem 0;
    }
    .consignee-box  {
      // margin-bottom: 30px;
      span {
        padding: 4px 10px;
        margin: 0 10px;
        font-size: 0.5rem;
        border-radius: 5px;
        border: 1px solid #fff;
      }
    }
    .btn {
      width: 65%;
      padding: 0.45rem;
      font-size: 0.68rem;
      border-radius: 10px;
      letter-spacing: 5px;
      margin-top: 0.54rem;
    }

  }

  input.el-input__inner,
  .search-wrapper .search-box .input-box .btn-search {
    height: 0.58rem !important;
    line-height: 0.58rem !important;
    font-size: 0.24rem;
  }

  
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/userSave/selectConsignee.vue